const IMAGES = {
  logo: require("./logo.svg").default,
  avatar: require("./image-avatar.jpg"),
  empryIllusration: require("./illustration-empty.svg").default,
  iconSun: require("./icon-sun.svg").default,
  iconMoon: require("./icon-moon.svg").default,
  iconPlus: require("./icon-plus.svg").default,
  iconDelete: require("./icon-delete.svg").default,
  iconCheck: require("./icon-check.svg").default,
  iconCalendar: require("./icon-calendar.svg").default,
  iconArrowDown: require("./icon-arrow-down.svg").default,
  iconArrowLeft: require("./icon-arrow-left.svg").default,
  iconArrowRight : require('./icon-arrow-right.svg').default,
};

export default IMAGES;
